module.exports = __webpack_public_path__ + "img/crustaceos.6639587b.svg";